import moment from 'moment';
import { readCreditBuilderProfile } from "../actions";
import { getIdentityId, getIsCreditBuilderProfileStale, getTuCreditReportPulledAt, getUserHasCreditBuilderProfile } from "../selectors";
import { startPolling } from "../utils/polling";
var CREDIT_BUILDER_POLLING_INTERVAL = 2000;
var CREDIT_BUILDER_POLLING_TIMEOUT_HOURS = 12;

var createCreditBuilderPoller = function createCreditBuilderPoller() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      dispatch = _ref.dispatch,
      pollingInterval = _ref.pollingInterval;

  /**
   * Current polling state. If polling is active, this will be a function that
   * stops polling. Otherwise it will be null. This state is controlled by
   * ensureStartedPolling and ensureStoppedPolling.
   */
  var stopPolling = null;
  /**
   * Function that checks for updated credit builder profile and updates.
   */

  var poll = function poll() {
    return dispatch(readCreditBuilderProfile());
  };
  /**
   * Function that determines how long to wait until the next poll.
   *
   * Poll every 2 seconds for roughly the first 10 seconds, then poll every
   * 10 seconds (based on the default pollingInterval of 2 seconds).
   */


  var getDelay = function getDelay(count) {
    return count < 5 ? pollingInterval : 5 * pollingInterval;
  };
  /**
   * Start polling (if not already started).
   */


  var ensureStartedPolling = function ensureStartedPolling() {
    if (stopPolling == null) {
      stopPolling = startPolling({
        poll: poll,
        getDelay: getDelay
      });
    }
  };
  /**
   * Stop polling (if not already stopped).
   */


  var ensureStoppedPolling = function ensureStoppedPolling() {
    if (stopPolling) {
      stopPolling();
      stopPolling = null;
    }
  };

  var handleState = function handleState(_ref2) {
    var identity = _ref2.identity;
    var currentIdentityId = getIdentityId(identity);
    var tuProfilePulledAt = getTuCreditReportPulledAt(identity);
    var userHasCreditBuilderProfile = getUserHasCreditBuilderProfile(identity);
    var isCreditBuilderProfileStale = getIsCreditBuilderProfileStale(identity);
    /**
     * When the credit builder profile and TU profile pulled at timestamps
     * aren't the same, start polling until the timestamps actually match up
     * or we exceed the polling timeout. If the user doesn't have an identity id
     * i.e. they're logged out, stop polling.
     */

    if (currentIdentityId && userHasCreditBuilderProfile && isCreditBuilderProfileStale && moment().diff(tuProfilePulledAt, 'hours') <= CREDIT_BUILDER_POLLING_TIMEOUT_HOURS) {
      ensureStartedPolling();
    } else {
      ensureStoppedPolling();
    }
  };

  return handleState;
};

export default (function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$pollingInterval = _ref3.pollingInterval,
      pollingInterval = _ref3$pollingInterval === void 0 ? CREDIT_BUILDER_POLLING_INTERVAL : _ref3$pollingInterval;

  return (// return Redux middleware
    function (_ref4) {
      var dispatch = _ref4.dispatch,
          getState = _ref4.getState;
      // No polling when running on server -- noop middleware
      if (!process.browser) return function (next) {
        return function (action) {
          return next(action);
        };
      };
      var handleState = createCreditBuilderPoller({
        dispatch: dispatch,
        pollingInterval: pollingInterval
      });
      return function (next) {
        return function (action) {
          var result = next(action);
          handleState(getState());
          return result;
        };
      };
    }
  );
});